import { Api } from '../../Api';
import { ListResult } from '../../interfaces';
import { IDtcReportsDto } from './interfaces';
import { IDtcReportsGetQuery, IDtcReportsDownloadGetQuery } from './query';

export class DtcReports {
    private static _basePath = '/Reports';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${DtcReports._basePath}`;
        return {
            async get(query: IDtcReportsGetQuery) {
                const path = '/';
                return await Api.get<ListResult<IDtcReportsDto>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async download({ fileName, reportType }: IDtcReportsDownloadGetQuery) {
                const path = '/download';
                return await Api.get<string>({
                    path: `${basePath}${path}`,
                    query: { fileName, reportType },
                });
            },
        };
    }
}
